import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d99a00c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-full" }
const _hoisted_2 = { class: "flex h-full" }
const _hoisted_3 = { class: "w-96 border" }
const _hoisted_4 = { class: "w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HistoryContainer = _resolveComponent("HistoryContainer")!
  const _component_UILoading = _resolveComponent("UILoading")!
  const _component_IframeComponent = _resolveComponent("IframeComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createBlock(_Suspense, null, {
        default: _withCtx(() => [
          _createVNode(_component_HistoryContainer, {
            templateId: _ctx.templateId,
            locationId: _ctx.locationId,
            service: _ctx.service,
            class: "w-96 border",
            "onUpdate:version": _ctx.switchPreview
          }, null, 8 /* PROPS */, ["templateId", "locationId", "service", "onUpdate:version"])
        ]),
        fallback: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_UILoading)
          ])
        ]),
        _: 1 /* STABLE */
      })),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.state.loading)
          ? (_openBlock(), _createBlock(_component_UILoading, { key: 0 }))
          : (_openBlock(), _createBlock(_component_IframeComponent, {
              key: 1,
              html: _ctx.state.previewData
            }, null, 8 /* PROPS */, ["html"]))
      ])
    ])
  ]))
}